export default "__VITE_ASSET__Dvl4XaMr__"